import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useFetchTeamsQuery } from '../../store/team/TeamApi';
import { CircularProgress, Paper } from '@mui/material';
import { useParams } from 'react-router';

const columns = [
    { 
        field: 'id', 
        headerName: 'ID', 
        width: 90, 
    },
    {
      field: 'label',
      headerName: 'Team',
      width: 100,
      editable: false,
    },
    {
      field: 'vacationType',
      headerName: 'Besuchsart',
      width: 150,
      editable: false,
      valueGetter: (value, row) => {
        switch (value)
        {
            case 'overnight': return 'Übernachtungsgäste';
            case 'weekend': return 'Wochenendsgäste';            
            default: return 'Tagesgäste';
        }
    },
    },
    {
        field: 'players',
        headerName: 'SpielerInnen',
        editable: false,
        width: 150,
    },
    {
        field: 'fellows',
        headerName: 'Mitreisende',
        editable: false,
        width: 100,
    },
    {
        field: 'firstDay',
        headerName: 'Anreisetag',
        editable: false,
        width: 100,
        valueGetter: (value, row) => {
            switch (value)
            {
                case 'saturday': return 'Samstag';
                default: return 'Freitag';
            }
        },
    },
    {
        field: 'fridayLunch',
        headerName: 'Fr. Abendessen',
        editable: false,
        width: 150,
    },
    {
        field: 'saturdayBreakfast',
        headerName: 'Sa. Frühstück',
        editable: false,
        width: 150,
    },
    {
        field: 'saturdayLunch',
        headerName: 'Sa. Abendessen',
        editable: false,
        width: 150,
    },
    {
        field: 'sundayBreakfast',
        headerName: 'So. Frühstück',
        editable: false,
        width: 150,
    },
    {
        field: 'barSets',
        headerName: 'Bierbänke',
        editable: false,
        width: 150,
    },
];

export default function TeamOverview()
{
  
  const params = useParams();
  const clubLabel = params.clubLabel;
  const selectedYear = params.year;

  const {data:teams, isLoading:teamsAreLoading} = useFetchTeamsQuery({
    year: selectedYear, 
    clubLabel: clubLabel,
  });

  return(        
    <Paper>
      <Box display='flex' justifyContent='center' >
        {
          teamsAreLoading
          ? <CircularProgress />
          : <DataGrid
              rows={teams}
              columns={columns}              
              showToolbar
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
                columns: {
                  columnVisibilityModel: 
                  {                    
                    id: false,
                  },
                },
              }}
              pageSizeOptions={[10]}
            />
        }        
      </Box>
    </Paper> 
  );
};